import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanDeactivate, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from "@angular/router";
import { Observable, of } from "rxjs";
import { AuthService } from "@services/auth.service";
import { CourseService } from "@services/course.service";
import { map, catchError } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class LoginAuthGuard implements CanActivate, CanActivateChild, CanDeactivate<unknown>, CanLoad {

  constructor(
    private authService: AuthService,
    private courseService: CourseService,
    private router: Router
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {

    if (!this.authService.loggedIn()) {
      //return an observable of a UrlTree to redirect to login
      return of(this.router.createUrlTree(['/login']));
    }

    return this.courseService.isCourseActive().pipe(
      map(active_courses => {
        const userRole = this.authService.getRole()

        // Safe array access
        const isCourseActive = active_courses && active_courses.length > 0 && active_courses[0];

        //Logic to determin access
        switch (true) {
          case !isCourseActive && userRole === "User":
            return this.router.createUrlTree(['/construction']);
          case isCourseActive && userRole === "User":
            return true;
          case userRole === "Admin":
            return true;
          default:
            return this.router.createUrlTree(['/login']);
        }
      }),
      catchError(() => {
        return of(this.router.createUrlTree(['/login']))
      })
    );
  }

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.canActivate(next, state);
  }
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return true;
  }
  canLoad(
    route: Route,
    segments: UrlSegment[]): Observable<boolean> | Promise<boolean> | boolean {
    return true;
  }

}
